import React from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';

import style from 'style';
import * as track from 'lib/track';
import img from 'assets/physiotherapist-and-boy-holding-ball-455x256.png';
import StarRating from 'components/widgets';
import { getImageHeightAndSize, getRatingValue } from 'lib/util';


const imageWidth = 140;
const { imageHeight, imageSize } = getImageHeightAndSize(imageWidth);

const imageWidthFlex = 120;
const { imageHeight: imageHeightFlex, imageSize: imageSizeFlex } = getImageHeightAndSize(imageWidthFlex);


const Container = styled.div`
  border: 1px solid ${style.colors.lightBorder};
  box-shadow: ${style.shadow(15)};
  border-radius: 16px;
  padding: 25px 20px;
  background-color: ${style.colors.white};
  width: 210px;
  height: 190px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  
  ${({$flex}) => $flex && css`
    border-radius: 12px;
    flex-direction: row;
    column-gap: 7px;
    align-items: center;
    width: 245px;
    height: 68px;
    padding: 0;
    box-shadow: ${style.glowingShadow(15)};
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    border-color: #fdedc1;
    overflow: hidden;
  `}

  :hover {
    border-color: ${style.colors.secondary};
    ${({$flex}) => $flex && css`
      transform: translateY(-2px);
      box-shadow: ${style.glowingShadow(25)};
      border-color: #ffd566;
    `}
  }
  
  .service-image {
    width: ${imageWidth};
    height: ${imageHeight};
    
    ${({$flex}) => $flex && css`
      width: ${imageWidthFlex};
      height: ${imageHeightFlex};
    `}
  }

  .service-detail {
    margin-top: 1rem;
    ${({$flex}) => $flex && css`
      margin-top: 0;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: end;
      align-items: start;
      color: #34988c;
      padding: 2px 10px 2px 0;
    `}
  }

  .title {
    text-align: center;
    max-height: 2.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 15px;
    font-weight: 700;
    ${({$flex}) => $flex && css`
      margin-left: 3px;
      font-weight: 700;
      font-size: 14px;
      text-align: start;
    `}
  }

  .rating-container {
    display: flex;
    column-gap: 5px;
    align-items: center;
    justify-content: center;
    
    ${({$flex}) => $flex && css`
      .MuiRating-sizeSmall {
        font-size: 15px !important;
      }
    `}
  }

  .rating {
    font-size: 12px;
    font-weight: 500;
  }

  .review-count {
    font-size: 12px;
    font-weight: 500;
    margin-top: 3px;
  }

  .sponsored {
    position: absolute;
    top: -25px;
    right: 0;
    color: ${style.colors.palette.squash};
    font-size: 12px;
    font-weight: 400;
    text-shadow: 1px 1px #e8e8e8;
    cursor: default;
    border: 1px solid ${style.colors.palette.squash};
    padding: 0 4px;
    border-radius: 6px;
  }
`;

const SmallProviderCard = (
  {
    title,
    uuid,
    url,
    imagePath,
    rating,
    reviewCount,
    eventTrackerName,
    hideBadge,
    flex,
  }) => {

  return (
    <Container
      onClick={() => {
        track.sendEvent(
          eventTrackerName,
          track.EVENT_CLICK, {provider_uuid: uuid});
        window.open(url, '_blank');
      }}
      $flex={flex}
    >
      {!hideBadge && <div className="sponsored">Featured Partner</div>}
      <img
        src={imagePath ? (imagePath + (flex ? imageSizeFlex : imageSize)) : img}
        alt={title}
        className="service-image"
      />
      <div className="service-detail">
        <div className="title">{title}</div>
        <div className="rating-container">
          <StarRating rating={getRatingValue(rating)} size="small"/>
          <div className="review-count">({reviewCount})</div>
        </div>
      </div>
    </Container>
  );
};

SmallProviderCard.propTypes = {
  title: PropTypes.string,
  uuid: PropTypes.string,
  url: PropTypes.string,
  imagePath: PropTypes.string,
  rating: PropTypes.number,
  reviewCount: PropTypes.number,
  eventTrackerName: PropTypes.string,
  hideBadge: PropTypes.bool,
  flex: PropTypes.bool,
};


export default SmallProviderCard;

